<div #container class="wrapper" [style]="{width: width, height: height}"></div>
